import { Component, OnInit } from "@angular/core";
import { AddTypeDocumentGarantieComponent } from "./add-type-document-garantie/add-type-document-garantie.component";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TypeDocumentGarantie } from "../../core/model/garanties/type-document-garantie";
import { TypeDocumentChampGarantieService } from "../../core/service/type-document-champ-garantie.service";

@Component({
  selector: "app-types-documents-garanties",
  templateUrl: "./types-documents-garanties.component.html",
  styleUrls: ["./types-documents-garanties.component.scss"],
})
export class TypesDocumentsGarantiesComponent implements OnInit {
  typesDocumentsGaranties: TypeDocumentGarantie[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _typeDocumentGarantieService: TypeDocumentChampGarantieService
  ) {}

  ngOnInit() {
    this.getTypeDocumentGaranties();
  }

  getTypeDocumentGaranties() {
    this._typeDocumentGarantieService
      .getTypeDocumentGaranties()
      .subscribe((data) => {
        this.typesDocumentsGaranties = data;
      });
  }

  deleteDetail(group: TypeDocumentGarantie) {}

  editDetail(typeDocumentGarantie: TypeDocumentGarantie) {
    const modalRef = this.modalService.open(AddTypeDocumentGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class",
    });

    modalRef.componentInstance.typeDocumentGarantie = typeDocumentGarantie;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getTypeDocumentGaranties();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addTyeDocumentGarantie() {
    const modalRef = this.modalService.open(AddTypeDocumentGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "type-document-garantie-modal",
    });
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getTypeDocumentGaranties();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
